export default [
    {
        path: "/owner/transform",
        name: "owner-transform",
        component: () => import("@/views/owner/transform.vue"),
    },
]